export const otpModalState = (state) => state?.otpModal;
